import PropTypes from 'prop-types'
import {
  Datagrid,
  DateField,
  ListContextProvider,
  TextField,
  useList,
  useGetList,
} from 'react-admin'
import { Box } from '@mui/material'
import ComponentWrapper from './ComponentWrapper'
import ViewQuoteButton from './ViewQuoteButton'

export default function InboundNotifications({ userId }) {
  const { data, isPending } = useGetList('lead-notifications', {
    pagination: { page: 1, perPage: 1000 },
    filter: {
      'admin.id': userId,
      displayDropped: false,
      dismissed: false,
      noteType: 1,
      payload: 'Inbound:',
    },
    sort: { field: 'targetTimestamp', order: 'ASC' },
  })

  const listContext = useList({
    data,
    isPending,
    perPage: 10,
  })

  // Dont show section if data empty
  if (isPending || data === undefined || data.length === 0) {
    return <></>
  }

  return (
    <ComponentWrapper title={'Inbound Notifications'}>
      <ListContextProvider value={listContext}>
        <Datagrid
          bulkActionButtons={false}
          sx={{
            '& .RaDatagrid-table': {
              tableLayout: 'fixed',
              width: '100%',
            },
            '& .column-quoteRequest\\.leadContact\\.vehicle\\.registration': {
              width: '15%',
            },
            '& .column-payload': {
              width: '55%',
              maxWidth: 0,
            },
            '& .column-targetTimestamp': {
              width: '20%',
            },
            '& .column-actions': {
              width: '10%',
            },
          }}
        >
          <TextField
            label="Vehicle details"
            source="quoteRequest.leadContact.vehicle.registration"
            sx={{ color: '#fc0', fontWeight: 'bold' }}
          />
          <TextField
            label="Note"
            source="payload"
            sx={{
              display: 'block',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          />
          <DateField
            label="Due time"
            source="targetTimestamp"
            showTime={true}
            locale="en-GB"
            sortable={false}
          />
          <Box sx={{ display: 'flex', gap: 1 }}>
            <ViewQuoteButton />
          </Box>
        </Datagrid>
      </ListContextProvider>
    </ComponentWrapper>
  )
}

InboundNotifications.propTypes = {
  userId: PropTypes.string,
}
